import { ReactNode } from 'react';
import { ActionIcon, Flex, Menu, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import {
	COUNT_TONE_COLORS,
	CountTone,
	GroupMenuItem,
} from '@dealstack/frontend/shared/components/ExpandablePersonCard/GroupHeader.types';

interface Props {
	name: string;
	count: number | string;
	menuItems?: GroupMenuItem[];
	menuTestId?: string;
	rightContent?: ReactNode;
	countTone?: CountTone;
}

export const GroupHeader = ({
	name,
	count,
	menuItems,
	menuTestId,
	rightContent,
	countTone = 'neutral',
}: Props) => {
	const countColors = COUNT_TONE_COLORS[countTone];
	return (
		<Flex justify="space-between" align="center">
			<Flex align="center" gap="0.5rem">
				<Text fw={700} size="0.75rem" c="dark.0">
					{name}
				</Text>
				<Flex
					align="center"
					justify="center"
					w="1.25rem"
					h="1.25rem"
					p="0.25rem 0.375rem"
					bg={countColors.bg}
					style={{ borderRadius: '1rem' }}
				>
					<Text size="0.5625rem" c={countColors.color}>
						{count}
					</Text>
				</Flex>
				{rightContent}
			</Flex>
			{menuItems && menuItems.length > 0 && (
				<Menu position="bottom-end" width="12.5rem">
					<Menu.Target>
						<ActionIcon data-testid={menuTestId}>
							<Icon
								variant="more-v3"
								size="md"
								color={defaultTheme.v3.colors.black[0]}
							/>
						</ActionIcon>
					</Menu.Target>
					<Menu.Dropdown p="0.25rem">
						{menuItems.map((item) => (
							<Menu.Item
								key={item.key}
								onClick={item.onClick}
								p="0.5rem"
								disabled={item.disabled}
								data-testid={item.testId}
							>
								<Text size="0.875rem" c="dark.9">
									{item.label}
								</Text>
							</Menu.Item>
						))}
					</Menu.Dropdown>
				</Menu>
			)}
		</Flex>
	);
};
